export default __webpack_public_path__ + "locales/es/BackupCodesDialog.json?hash=bcb42704af7d47860e5d46d9d98bebf9";